/**
 * Where a signed-in user belongs, by role.
 *
 * This lived in three places that had drifted apart: the password login knew
 * about `paralegal`, the Google callback did not, so lawyer support staff
 * signing in with Google were dropped on `/` instead of the lawyer area. One
 * map so a new role cannot be added to some entry points and not others.
 *
 * `paralegal` shares the lawyer dashboard deliberately — see App.js, which
 * admits both to the same routes.
 */

export const ROLE_HOME = {
  client: '/client',
  lawyer: '/lawyer',
  paralegal: '/lawyer',
  funder: '/funder',
  admin: '/admin',
  growth_partner: '/growth-partner',
};

/**
 * Landing path for `role`. `fallback` is the caller's choice for a role it does
 * not recognise — signup knows it just made a client, while a login callback
 * would rather send an unknown role to the root than guess.
 */
export function roleHome(role, fallback = '/') {
  return ROLE_HOME[role] || fallback;
}
